import React, { FC } from "react";
import Modal, { ModalController } from "Components/Modal/Modal";
import { ScheduleGroup } from "domain-entities";
import ScheduleGroupForm from "./ScheduleGroupForm";

interface Props {
	modalController: ModalController<ScheduleGroup>;
	remove: (scheduleGroup: ScheduleGroup) => void;
}

const ScheduleGroupModal: FC<Props> = (props) => {
	if (props.modalController.isOpen && props.modalController.item) {
		return (
			<Modal
				modalController={props.modalController}
			>
				<ScheduleGroupForm
					scheduleGroup={props.modalController.item}
					remove={props.remove}
					close={props.modalController.close}
				/>
			</Modal>
		);
	} else {
		return null;
	}
};

export default ScheduleGroupModal;
